module.exports = __webpack_public_path__ + "static/pop_xiaoai.856abcb9.png";